import { useState, useEffect } from 'react';
import { encryptText } from '../functions/LoginCheck';
import { DefaultTextCustomMSG, PasswordText, PasswordTextCustomMSG } from '../functions/TextModule'

export default function Profile()
{
    const [dpMessage, setDpMessage] = useState("")
    const [emptyPWD, setEmptyPWD] = useState(false);
    const [emptyNewPWD, setEmptyNewPWD] = useState(false);
    const [emptyNewCfmPWD, setEmptyNewCfmPWD] = useState(false);
    const [pwdMessage, setPwdMessage] = useState("(Cannot be empty)");
    const [newPwdMessage, setNewPwdMessage] = useState("(Cannot be empty)");
    const [showPwd, setShowPwd] = useState(true);
    const [showNewPwd, setShowNewPwd] = useState(true);
    const [showNewCfmPwd, setShowNewCfmPwd] = useState(true);

    useEffect(()=> {
        document.getElementById("dpnametxt").value = localStorage.getItem("lh_api_display_name")
    })

    return (
        <div className="UserProfile">
            <div className="UserProfile-Container1">
                <div className="UserProfile-Container2">
                    <DefaultTextCustomMSG
                        name="Display Name"
                        inputID="dpnametxt"
                        toggleErrorTxt={true}
                        // task={}
                        message={dpMessage}
                    />
                    <div className="UserProfile-SaveButton"
                        onClick={() => saveDisplayName(setDpMessage)}>
                        Save
                    </div>
                </div>
                <div className="aLine"/>
                <div className="UserProfile-PWDContainer1">
                    <div className="UserProfile-PWDContainer2">
                        <div className="UserProfile-PWDContainer3">
                            <PasswordTextCustomMSG
                                name="Old Password"
                                inputID="passwordtxt"
                                toggleErrorTxt={emptyPWD || pwdMessage !== "(Cannot be empty)"}
                                // task={handleKeyDown}
                                showElement={showPwd}
                                setShowElement={setShowPwd}
                                message={pwdMessage}
                            />
                        </div>
                        <div className="UserProfile-SaveButton"
                            onClick={() => savePassword(setEmptyPWD, setEmptyNewPWD, setEmptyNewCfmPWD, setNewPwdMessage, setPwdMessage)}>
                            Save
                        </div>
                    </div>
                        <PasswordTextCustomMSG
                            name="New Password"
                            inputID="newpasswordtxt"
                            toggleErrorTxt={emptyNewPWD || newPwdMessage !== "(Cannot be empty)"}
                            // task={handleKeyDown}
                            showElement={showNewPwd}
                            setShowElement={setShowNewPwd}
                            message={newPwdMessage}
                        />
                        <PasswordText
                            name="Confirm New Password"
                            inputID="cfmnewpasswordtxt"
                            toggleErrorTxt={emptyNewCfmPWD}
                            // task={handleKeyDown}
                            showElement={showNewCfmPwd}
                            setShowElement={setShowNewCfmPwd}
                        />
                </div>
            </div>
        </div>
    );
}

function saveDisplayName(setDpMessage) {
    let dp = document.getElementById("dpnametxt").value
    localStorage.setItem("lh_api_display_name", dp);
    fetch(process.env.REACT_APP_API_BASE_URL + "/users/profile/update-displayname", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem('lh_api_access_token')
        },
        body: JSON.stringify({
            "displayname": dp
        })
    })
    .then(response => response.json())
    .then(response => {
        if (response["Success"] !== undefined)
            setDpMessage("Saved");
        else
            setDpMessage("Failed to update display name.");
    })
    .catch(error => console.error(error));
}

function savePassword(setEmptyPWD, setEmptyNewPWD, setEmptyNewCfmPWD, setNewPwdMessage, setPwdMessage) {
    let pwd = document.getElementById("passwordtxt");
    let newPwd = document.getElementById("newpasswordtxt");
    let newCfmPwd = document.getElementById("cfmnewpasswordtxt");
    setPwdMessage("(Cannot be empty)");
    setEmptyPWD(pwd.value === "");
    setEmptyNewPWD(newPwd.value === "");
    setEmptyNewCfmPWD(newCfmPwd.value === "");
    if (newPwd.value !== newCfmPwd.value)
        setNewPwdMessage("(Password do not match)")
    else 
    {
        if (pwd.value !== "" && newPwd.value !== "" && newCfmPwd.value !== "")
        {
            fetch(process.env.REACT_APP_API_BASE_URL + "/users/profile/update-password", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('lh_api_access_token')
                },
                body: JSON.stringify({
                    "password": encryptText(pwd.value),
                    "newpassword": encryptText(newPwd.value)
                })
            })
            .then(response => response.json())
            .then(response => {
                if (response["Success"] !== undefined) {
                    pwd.value = "";
                    newPwd.value = "";
                    newCfmPwd.value = "";
                    setPwdMessage("Saved");
                }
                else
                    setPwdMessage("Invalid Password.");
            })
            .catch(error => console.error(error));
        }
        setNewPwdMessage("(Cannot be empty)")
    }
}